module.exports = __webpack_public_path__ + "img/person_search_opsz20B.fe96eb91.svg";